import Spinner from '../../components/Spinner/Spinner'
import {
  StyledMuiButton,
  BUTTON_SIZES,
  BUTTON_VARIANTS,
  type ButtonProps,
} from './Button.styles'

function Button({
  children,
  loading,
  disabled,
  variant = 'contained',
  color = 'primary',
  testId,
  ...otherProps
}: ButtonProps) {
  return (
    <StyledMuiButton
      variant={variant}
      color={color}
      disabled={disabled}
      data-testid={testId}
      {...otherProps}
    >
      {loading ? <Spinner white /> : children}
    </StyledMuiButton>
  )
}

export default Button
export { BUTTON_SIZES, BUTTON_VARIANTS }
export type { ButtonProps }
